<template>
  <b-modal
    :id="idModal"
    :ref="idModal"
    size="xl"
    body-classes="p-0"
    @hidden="reseteaValores"
    @show="cargaInicial"
  >
    <div class="text-center text-muted mb-4">
      <small>Editor de Grupo</small>
    </div>
    <b-form role="form">
      <base-input label="Curso">
        <b-select
          type="select"
          label="Curso"
          placeholder="Curso"
          :options="cursos"
          v-model="grupo.id_curso"
        ></b-select>
      </base-input>
    </b-form>
    <b-form role="form">
      <base-input
        label="Nombre de Grupo"
        v-model="grupo.nombre_grupo"
        class="mb-3"
        placeholder="Nombre"
      >
      </base-input>
      <base-input
        label="Nombre de Aula"
        v-model="grupo.nombre_clase"
        class="mb-3"
        placeholder="Nombre"
      >
      </base-input>
    </b-form>
    <b-form>
      <tabla-catequistas-simple :multiple="true" :data="catequistas" />
    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="primary"
          size="sm"
          class="float-right"
          @click="editaGrupo()"
        >
          Guardar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import tablaCatequistasSimple from "@/components/Tables/TablaCatequistasSimple.vue";

import "@/components/Spinner-Load/loader.css";
import { spinner } from "@/components/Spinner-Load/loader.js";
const loader = spinner();

export default {
  components: { tablaCatequistasSimple },
  props: {
    idModal: {
      type: String,
    },
    selectGrupo: {
      type: Object,
      default: () => ({
        id: null,
        id_curso: null,
        nombre_grupo: null,
        nombre_clase: null,
        catequistas: [],
      }),
    },
  },
  data() {
    return {
      grupo: {
        id: null,
        id_curso: null,
        nombre_grupo: null,
        nombre_clase: null,
        catequistas: [],
      },
    };
  },
  computed: {
    catequistas() {
      loader.close();
      if (this.$store.getters.getTodosCatequistasSimple != undefined) {
        return this.$store.getters.getTodosCatequistasSimple.map((element) => {
          let select = undefined;
          if (this.selectGrupo && this.selectGrupo.catequistas.length > 0) {
            select = this.selectGrupo.catequistas.find(
              (element2) => element.id == element2.id
            );
          }
          return {
            check: select ? true : false,
            id: element.id,
            catequista:
              element.nombre +
              " " +
              element.apellido1 +
              " " +
              element.apellido2,
          };
        });
      } else {
        loader.open();
        this.$store.dispatch("cargaCatequistasSimple");
        return [];
      }
    },
    cursos() {
      if (this.$store.getters.getCursos != undefined) {
        loader.close();
        return this.$store.getters.getCursos.map((element) => {
          return {
            value: element.id,
            text: element.nombre,
          };
        });
      } else {
        loader.open();
        this.$store.dispatch("cargarCursosGruposCatequistas");
        return [];
      }
    },
  },
  methods: {
    reseteaValores() {
      this.grupo = {
        id: null,
        id_curso: null,
        nombre_grupo: null,
        nombre_clase: null,
        catequistas: [],
      };
    },

    cargaInicial() {
      this.reseteaValores();
      if (this.selectGrupo != null) {
        this.grupo = this.selectGrupo;
      }
      
    },
    editaGrupo() {
      this.grupo.catequistas =
        this.$store.getters.getTodosCatequistasSimple.filter((element) => {
          let elemento = this.catequistas.find(
            (element2) => element.id == element2.id && element2.check
          );
          if (elemento) {
            return element;
          }
        });
      this.$emit("editaGrupo", this.grupo);
    },
  },
};
</script>
<style></style>
